
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[show]/episode/[episode]",
      function () {
        return require("private-next-pages/podcasts/[show]/episode/[episode].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/[show]/episode/[episode]"])
      });
    }
  